import {
  IFileObject,
  IImageInfo,
  IProjectData,
  ISelectedAlgo,
  ITrainData,
  ITrainStatusInfo,
  IDataSetObject,
  ILabelCount,
} from "@types";
import { atom, selectorFamily, atomFamily, AtomEffect } from "recoil";
import { ReportItem, TemplateList, TemplateReportItem } from "../@types";
import { IProjectApiResponse } from "@types";
import { steps_1, steps_2 } from "../components/joyride/step1";

export const localFileState = atom<File[]>({
  key: "localFileKey",
  default: [],
});

export const serverFileState = atom<string[]>({
  key: "serverFileKey",
  default: [],
});

export const serverFileSecondState = atom<IFileObject[]>({
  key: "serverFileSecondKey",
  default: [],
});
// except.txt로 지정한 학습 제외 이미지 경로들 (검사 프로젝트: train에서 빼고 valid로 보냄)
export const exceptFileState = atom<string[]>({
  key: "exceptFileKey",
  default: [],
});

export const serverFilesNameState = atom<string[]>({
  key: "serverFilesNameKey",
  default: [],
});

export const tempFileState = atom<IFileObject[]>({
  key: "tempFileKey",
  default: [],
});

export const selectedFileState = atom<IDataSetObject[]>({
  key: "selectedFileState", // 고유한 키
  default: [], // 초기값은 빈 배열
});

// 라벨링 modal
export const labelModalPosState = atom({
  key: "labelModalPosKey",
  default: { x: 0, y: 0 },
});

// 라벨기록 modal
export const historyModalPosState = atom({
  key: "historyModalPosKey",
  default: { x: 0, y: 0 },
});

// 이미지필터 modal
export const filterModalPosState = atom({
  key: "filterModalPosKey",
  default: { x: 0, y: 0 },
});

// 키 설정 modal
export const KeyModalPosState = atom({
  key: "KeySettingModalPosKey",
  default: { x: 0, y: 0 },
});

export const openKeyModalState = atom({
  key: "openKeyModalKey",
  default: false,
});

export interface IProjectCountInfo {
  label_count: ILabelCount;
  total_count: number;
}

export const projectInfoState = atom<IProjectData | null>({
  key: "projectInfoKey",
  default: null,
});

export const projectCountInfoState = atom<IProjectCountInfo>({
  key: "projectCountInfoKey",
  default: {
    label_count: { total: 0 },
    total_count: 0,
  },
});

export const projectConfigState = atom<any | null>({
  key: "projectConfigKey",
  default: null,
});

export const projectsDataState = atom<IProjectApiResponse>({
  key: "projectsDataKey",
  default: {
    data: [],
    total: 0,
  },
});

export const selectedProjectState = atom<number | null>({
  key: "selectedProjectKey",
  default: null,
});

export const trainsDataState = atom<ITrainData[]>({
  key: "trainsDataKey",
  default: [],
});

// 프로젝트 내의 이미지
// export type ImageData = string | null;

export const selectedImageState = atom<IImageInfo>({
  key: "selectedImageKey",
  default: { path: "", label: "", score: 0 },
});

export const projectImagesInfoState = atom<IImageInfo[]>({
  key: "projectImagesInfoKey",
  default: [],
});

// ImageTable 다중 선택(seq) — 비어있지 않으면 LabelButton이 일괄 라벨링
export const multiSelectedSeqsState = atom<number[]>({
  key: "multiSelectedSeqsKey",
  default: [],
});

// 도움말 관련 상태관리 - 위치, 모달 open, 모드, 선택된 element, 도움말 내용, 도움말 고정상태
export const helpPosState = atom({
  key: "helpPosKey",
  default: { x: 100, y: 100 },
});

export const openHelpState = atom<boolean>({
  key: "openHelpKey",
  default: false,
});

export const helpModeState = atom<boolean>({
  key: "helpModeState",
  default: false,
});

export const helpTargetState = atom<string>({
  key: "helpTargetState",
  default: "",
});

export const helpContentState = atom<string>({
  key: "helpContentKey",
  default: "",
});

export const helpFixState = atom<boolean>({
  key: "helpFixKey",
  default: false,
});

// 알고리즘 선택
export const selectedAlgoState = atom<ISelectedAlgo>({
  key: "selectedAlgoKey",
  default: {
    classCount: 5,
    algoId: null,
    algoName: null,
    images: [],
    labels: [],
  },
});

// 학습상태 체크
export const trainStatusInfoState = atom<ITrainStatusInfo>({
  key: "trainStatusInfoKey",
  default: {
    code: 0,
    status: "None",
    trainProjectId: -1,
    trainClass: "OK",
    isMultiClass: false,
    queue: [],
    message: "",
    train_time: 0,
    total_time: 0,
    isTrain: false,
  },
});

export const trainStatusState = atom<trainStatusResponse>({
  key: "trainStatusKey",
  default: {
    msg: "",
    project_id: null,
    state: "none",
    trainLog_id: "",
    step: "",
    train_id: "",
    train_time: 0,
    total_time: 1,
  },
});

// overview 표시항목 리스트
export const overviewClassListState = atom<string[]>({
  key: "overviewClassListKey",
  default: [],
});

// project의 class값
export const classListState = atom<string[]>({
  key: "classListKey",
  default: [],
});

export const isCreatingReportState = atom<boolean>({
  key: "isCreatingReportKey",
  default: false,
});

// 선택된 리포트 항목
export const selectedReportListState = atom<ReportItem[]>({
  key: "selectedReportListKey",
  default: [],
});

// 템플릿에 저장될 항목
export const templateReportListState = atom<TemplateList>({
  key: "templateReportListKey",
  default: {
    name: "",
    contents: [],
  },
});

// 데모모드 상태
export const demoModeState = atom<boolean>({
  key: "demoModeKey",
  // default: false,
  default: localStorage.getItem("demoMode") === "true", // localStorage에서 초기값 가져오기
});

// project의 label NG 데이터
export const ngDataState = atom<string[]>({
  key: "ngDataKey",
  default: [],
});

export const ngCountState = atom<number>({
  key: "ngCountKey",
  default: 0,
});

// project의 분석시 자동으로 채워줄 데이터
export const autoFillDataState = atom<string[]>({
  key: "autoFillDataKey",
  default: [],
});

// project select count 사용자화
export const projectSelectCountState = atom<number>({
  key: "projectSelectCountKey",
  default: 8,
});

// 학습진행 확인
export const trainingState = atom<boolean>({
  key: "trainingKey",
  default: false,
});

export const isTrainingState = atom<boolean>({
  key: "isTrainingKey",
  default: false,
});

function getTutorialCompletedDefault() {
  try {
    const raw = localStorage.getItem("userInfo");
    if (!raw) return false;

    const parsed = JSON.parse(raw);
    // console.log("Parsed userInfo:", parsed);
    return parsed?.config?.tutorial?.completed ?? false;
  } catch (e) {
    console.error("Failed to load tutorial.completed from localStorage:", e);
    return false;
  }
}

export const isTutorialState = atom<boolean>({
  key: "isTutorialKey",
  default: getTutorialCompletedDefault(),
});

export const isTutorialContinueState = atom<boolean>({
  key: "isTutorialContinueKey",
  default: false,
});

export const stepIndexState = atom<number>({
  key: "stepIndexKey",
  default: 0,
});

export const currentStepsState = atom({
  key: "currentStepsState",
  default: steps_1,
});

export const currentGroupState = atom({
  key: "currentGroupState",
  default: 1,
});

export const dataLoadingState = atom<boolean>({
  key: "dataLoadingKey",
  default: false,
});

export const tutorialState = atom({
  key: "tutorialState",
  default: {
    isActive: false,
    currentStepIndex: 0,
    currentPage: "",
    series: "",
  },
});

interface TutorialReadyState {
  path: string;
  ready: boolean;
}

export const tutorialReadyState = atom<TutorialReadyState>({
  key: "tutorialReadyState",
  default: { path: "", ready: false },
});

// 선택된 메뉴
export const selectedMenuState = atom({
  key: "selectedMenuKey",
  default: "대시보드",
});

// 검사통계 리포트 필터
export const inspStatusReportFilterState = atom({
  key: "inspStatusReportFilterKey",
  default: {
    client_ip: null,
    material_name: null,
  },
});

// 선택된 버튼
export const selectedButtonState = atom({
  key: "selectedButtonKey",
  default: "",
});

// 데이터 total값 (pagination을 위함)
export const totalCountState = atom({
  key: "totalCountKey",
  default: 1,
});

// 선택된 데이터의 uuid
export const selectedRowUuidState = atom({
  key: "selectedRowUuidKey",
  default: null,
});

// trainSelect modal 관련
export const ServerAndTrainState = atom({
  key: "ServerAndTrainKey",
  default: [],
});

// 학습 실행으로 선택된 인덱스 값들을 배열로 저장
export const selectedTrainIndexState = atom<number[]>({
  key: "selectedTrainIndexKey",
  default: [],
});

// 위 배열의 각 인덱스값마다의 상태관리
export const isTrainingSelectorState = selectorFamily<boolean, number>({
  key: "isTrainingKey",
  get:
    (index: number) =>
    ({ get }) => {
      const selectedIndexes = get(selectedTrainIndexState) as number[];
      return selectedIndexes.includes(index);
    },
  set:
    (index: number) =>
    ({ set, get }, newValue) => {
      const selectedIndexes = get(selectedTrainIndexState) as number[];
      if (newValue) {
        set(selectedTrainIndexState, [...selectedIndexes, index]);
      } else {
        set(
          selectedTrainIndexState,
          selectedIndexes.filter((i) => i !== index),
        );
      }
    },
});

export const leftTimeState = atomFamily({
  key: "leftTimeStateFamily",
  default: 0,
});

// 각 인덱스별 남은 train time 저장
export const leftTimeSelectorState = selectorFamily({
  key: "leftTimeKey",
  get:
    (index) =>
    ({ get }) => {
      return get(leftTimeState(index));
    },
  set:
    (index) =>
    ({ set }, newValue) => {
      set(leftTimeState(index), newValue);
    },
});

// 각 인덱스별 진행도 저장
export const progressSelectorState = selectorFamily({
  key: "progressKey",
  get:
    (index) =>
    ({ get }) => {
      return get(progressState(index));
    },
  set:
    (index) =>
    ({ set }, newValue) => {
      set(progressState(index), newValue);
    },
});

export const progressState = atomFamily({
  key: "progressStateFamily",
  default: 0,
});

// 각 인덱스별 server status 저장
export const selectedServerSelectorState = selectorFamily({
  key: "selectedServerKey",
  get:
    (index) =>
    ({ get }) => {
      return get(selectedServerStatusState(index));
    },
  set:
    (index) =>
    ({ set }, newValue) => {
      set(selectedServerStatusState(index), newValue);
    },
});

// 학습 진행관련 상태관리
export const selectedServerStatusState = atomFamily({
  key: "selectedServerStateFamily",
  default: null,
});

// 검사현황 필터
export const inspStatusFilterState = atom({
  key: "inspStatusFilterKey",
  default: {
    name: null,
    client_ip: null,
    label: null,
    lot: null,
    start_date: null,
    end_date: null,
  },
});

export const selectedRowsState = atom({
  key: "selectedRowsState",
  default: [],
});

// 공통 옵션 파라미터 관리
export const queryOptionsState = atom({
  key: "queryOptionsKey",
  default: {
    search_type: 0,
    keyword: null,
    sort_type: null,
    sort: null,
    page: 1,
    pageSize: 20,
  },
});

// 이미지 삭제 기능 여부
const localStorageEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    // 1. 초기화 시 localStorage 값 사용
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      try {
        setSelf(JSON.parse(savedValue) as T);
      } catch (e) {
        console.error(`Error parsing localStorage key "${key}":`, e);
      }
    }

    // 2. 상태가 변경될 때 localStorage에 저장
    onSet((newValue, _, isReset) => {
      if (isReset) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

export const imageDeleteEnabledState = atom({
  key: "imageDeleteEnabledState",
  default: false,
  effects_UNSTABLE: [localStorageEffect("imgEnableMode")],
});

// 이전 검색 파라미터 저장
export const tempFilterOptionState = atom({
  key: "tempFilterOptionKey",
  default: {},
});

// 모달 add, edit, view 모드
export const modeState = atom({
  key: "modeKey",
  default: "view",
});

export const saveInspRuleState = atom({
  key: "saveInspRuleState",
  default: {},
});

export const tableColumnState = atom<string[]>({
  key: "tableColumnKey",
  default: ["no", "image", "label", "aiLabel", "score"],
});

export const overkillPercentState = atom<number>({
  key: "overkillPercentKey",
  default: 0.0,
});

export const overkillCountState = atom<number>({
  key: "overkillCountKey",
  default: 0,
});

export const thresholdCustomState = atom<number>({
  key: "thresholdCustomKey",
  default: 0.5,
});

export const openDefectPreviewState = atom<boolean>({
  key: "openDefectPreviewKey",
  default: false,
});

export interface parentModelItem {
  id: number;
  uuid: string;
}

export const parentModelState = atom<parentModelItem | null>({
  key: "parentIdKey",
  default: null,
});

export const continueTrainState = atom<boolean>({
  key: "continueTrainKey",
  default: false,
});

type InspModelItem = {
  id: number;
  uuid: string;
  name: string;
  info: string | null;
  description: string;
};

export const selectedInspModelState = atom<InspModelItem | null>({
  key: "selectedInspModelKey",
  default: null,
});
